// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "../../../../revvComponents";

// Internal Imports
import { GlobalUtils } from "../../../../utils";

const { copyToClipBoardCSV } = GlobalUtils;

class CreationErrorMessage extends Component {
  state = {};

  _closePopup = () => {
    this.props.onClose("errorMessageScreen", false);
  };

  _copyTextToClipboard = () => {
    const comp = document.getElementById("csvupload-text");
    const copiedData = copyToClipBoardCSV(comp.innerText);
    if (copiedData) {
      Toastr.showToastr({
        type: "success",
        message: "Error log is copied to the clipboard.",
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Could not copy error log.",
        timeout: 3000,
      });
    }
  };

  _uploadCsvFile = () => {
    this.props.uploadAgainPopup("errorMessageScreen", false);
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        <div className="csvbulkupload-error-popup-wrapper">
          <div className="csvbulkupload-error-popup-body">
            <div
              className="csvbulkupload-error-popup-header"
              data-test="csvbulkupload-error-modal-heading">
              <span>Document creation failed</span>
            </div>
            {/* <div className="csvbulkupload-error-subheading">
              We have encountered below listed errors in the CSV, please fix
              them and retry
            </div>

            <div className="csvupload-body-wrapper" id="csvupload-text">
              {this.props.errorMessageData &&
                this.props.errorMessageData.length > 0 &&
                this.props.errorMessageData.map(err => (
                  <div className="csvupload-error-screen-body">
                    <FontAwesomeIcon
                      className="csvupload-info-icon"
                      icon={["far", "info-circle"]}
                    />
                    {err.message}
                  </div>
                ))}
            </div> */}
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreationErrorMessage;
